<div class="screen">
  <div class="screen-inner">
    <app-shell nav="back" action="none" [title]="title" [backTo]="backTo"></app-shell>

    @if (card) {
      @if (card.canPickGroup) {
        <label class="field field-inline">
          <span class="field-label">Group</span>
          <select name="groupId" [ngModel]="groupId" (ngModelChange)="changeGroup($event)">
            @for (group of card.groups; track group.groupId) {
              <option [ngValue]="group.groupId">{{ group.label }}</option>
            }
          </select>
        </label>
      } @else if (card.groupLabel) {
        <p class="section-label">{{ card.groupLabel }}</p>
      } @else if (card.teams.length > 1) {
        <label class="field field-inline">
          <span class="field-label">Team</span>
          <select name="teamId" [ngModel]="teamId" (ngModelChange)="changeTeam($event)">
            @for (team of card.teams; track team.teamId) {
              <option [ngValue]="team.teamId">{{ team.name }}</option>
            }
          </select>
        </label>
      }

      @if (card.notice) {
        <p class="page-note">{{ card.notice }}</p>
      }

      @if (hole && hole.lines.length > 0) {
        <a class="scorecard-link" [routerLink]="['/events', card.eventId, 'score', roundId, 'card']" [queryParams]="card.groupId ? { group: card.groupId } : {}">Scorecard</a>

        <section class="tee-card">
          <p class="tee-label">Hole {{ hole.displayHoleNumber || hole.sequence }} of {{ card.holes.length }} &middot; par {{ hole.par }}</p>
          <p class="tee-name" [style.color]="hole.teeColor || 'var(--text)'">{{ hole.teeName || 'Selected tee' }}</p>
          @if (card.runningTee) {
            <p class="tee-label">Carried from the last hole. It stops at the front and back sets.</p>
          }
        </section>

        @if (card.oceans6) {
          <p class="page-note">Keep exactly one par 3, one par 5, and four par 4s. You can discard a spare, but not the last one you still need.</p>
        }

        @for (line of hole.lines; track $index) {
          <section class="player-card">
            <p class="row-title">{{ line.displayName }}</p>
            <p class="row-meta">{{ line.strokes }} stroke{{ line.strokes === 1 ? '' : 's' }} &middot; net {{ line.net ?? '—' }}</p>
            <div class="stepper">
              <button type="button" [disabled]="saving" (click)="bump(line, -1)">&minus;</button>
              <div class="stepper-value" [class.stepper-unset]="line.gross == null">{{ line.gross ?? '--' }}</div>
              <button type="button" [disabled]="saving" (click)="bump(line, 1)">+</button>
            </div>
            @if (card.oceans6 && line.userId) {
              <div class="inline-actions">
                <button class="btn-secondary" type="button"
                        [disabled]="decisionLocked(line) || line.kept === true || !canKeep(hole.par, line.userId)"
                        (click)="setKept(line, true)">Keep</button>
                <button class="btn-secondary" type="button"
                        [disabled]="decisionLocked(line) || line.kept === false || !canDiscard(hole.par, hole.sequence, line.userId)"
                        (click)="setKept(line, false)">Discard</button>
                @if (line.kept === true) { <span class="pill">Keeping</span> }
                @if (line.kept === false) { <span class="pill pill-muted">Discarded</span> }
                @if (decisionLocked(line)) {
                  <p class="row-meta">Only a league organizer can change this.</p>
                }
                @if (mustKeep(hole, line)) {
                  <p class="row-meta">You have to keep this par {{ hole.par }}.</p>
                }
              </div>
            }
          </section>
        }

        @if (hole.countingScore != null) {
          <p class="section-label">Hole score {{ hole.countingScore }}</p>
        }

        <button class="btn-secondary clear-scores" type="button" [disabled]="saving || !hasScores || clearLocked" (click)="clearScores()">{{ clearLabel }}</button>

        <div class="hole-nav">
          <button class="btn-secondary" type="button" [disabled]="holeIndex === 0" (click)="previous()">Previous</button>
          <button class="btn-primary btn-inline" type="button" [disabled]="holeIndex === card.holes.length - 1 || needsDecision" (click)="next()">Next hole</button>
        </div>
        @if (needsDecision) {
          <p class="page-note">Keep or discard each score before the next hole.</p>
        }
      } @else if (card.holes.length === 0 && !card.notice) {
        <p class="page-note">This round has no holes yet. The organizer needs to save the course first.</p>
      }
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
